import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared';

import { PasswordRecoveryComponent } from './password-recovery.component';

@NgModule({
  declarations: [PasswordRecoveryComponent],
  imports: [CommonModule, SharedModule, RouterModule],
  exports: [PasswordRecoveryComponent],
})
export class PasswordRecoveryModule {}
